import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { datasetSettingsFields } from '@/datasets/settings/state/state';
import Error from '@/components/errors/Error';
import { cohortPerms } from '../sharing/state/state';
import { supportedCohortVisibilities } from '../state/state';
import { cohortPermissions } from '../constants';

const CohortNoDatasetAccess = ({ datasetAccess, datasetCohortVisibilities }) => {
  const intl = useIntl();
  let error = 'denied';
  if (datasetAccess) {
    if (datasetCohortVisibilities.length) {
      error = 'visibility.change';
    } else {
      error = 'visibility.denied';
    }
  }

  return (
    <Error
      warning
      title={intl.formatMessage({ id: `cohort.data.access.${error}.header` })}
      error={intl.formatMessage({ id: `cohort.data.access.${error}.message` })}
    />
  );
};

const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code)
      || { access: { dataset_access: false }, permissions: cohortPerms(), settings: datasetSettingsFields() };
  const datasetCohortVisibilities = role.permissions.cohorts.update && item.permissions[cohortPermissions.VISIBILITY]
    ? supportedCohortVisibilities(item) : [];

  return (
    {
      datasetCohortVisibilities,
      datasetAccess: item.access.dataset_access,
    }
  );
};

export default connect(mapStateToProps)(CohortNoDatasetAccess);
